<div fxLayout="column" id="register">
  <div
    fxLayout="column"
    fxLayoutAlign="center center"
    id="register-form-wrapper"
  >
    <div id="register-form" [@animateStagger]="{ value: '50' }">
      <div *ngIf="logoUrl" class="logo">
        <img
          alt="logo"
          [@animate]="{ value: '*', params: { x: '50px' } }"
          [src]="logoUrl"
        />
      </div>

      <div class="title" [@animate]="{ value: '*', params: { x: '-50px' } }">
        {{ titleText }}
      </div>

      <form
        name="registerForm"
        novalidate
        [@animate]="{ value: '*', params: { duration: '300ms', y: '100px' } }"
        [formGroup]="registerForm"
      >
        <mat-form-field
          [@animate]="{ value: '*', params: { x: '50px' } }"
          [appearance]="appearance"
        >
          <input formControlName="name" matInput [placeholder]="nameText" />
          <mat-icon matSuffix [color]="color">person</mat-icon>
          <mat-error>
            {{ nameErrorRequiredText }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          [@animate]="{ value: '*', params: { x: '50px' } }"
          [appearance]="appearance"
        >
          <input
            formControlName="email"
            matInput
            autocomplete="username"
            [placeholder]="emailText"
          />
          <mat-icon matSuffix [color]="color">email</mat-icon>
          <mat-error *ngIf="registerForm.get('email')?.hasError('required')">
            {{ emailErrorRequiredText }}
          </mat-error>
          <mat-error *ngIf="registerForm.get('email')?.hasError('email')">
            {{ emailErrorPatternText }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          [@animate]="{ value: '*', params: { x: '50px' } }"
          [appearance]="appearance"
        >
          <input
            formControlName="password"
            matInput
            type="password"
            autocomplete="new-password"
            [placeholder]="passwordText"
          />
          <mat-icon matSuffix [color]="color">lock</mat-icon>
          <mat-error *ngIf="registerForm.get('password')?.hasError('required')">
            {{ passwordErrorRequiredText }}
          </mat-error>
          <mat-error
            *ngIf="registerForm.get('password')?.hasError('minlength')"
          >
            {{ passwordErrorMinLengthText }}
          </mat-error>
          <mat-error
            *ngIf="registerForm.get('password')?.hasError('maxlength')"
          >
            {{ passwordErrorMaxLengthText }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          [@animate]="{ value: '*', params: { x: '50px' } }"
          [appearance]="appearance"
        >
          <input
            formControlName="passwordConfirm"
            matInput
            type="password"
            autocomplete="new-password"
            [placeholder]="passwordConfirmationText"
          />
          <mat-icon matSuffix [color]="color">lock</mat-icon>
          <mat-error
            *ngIf="registerForm.get('passwordConfirm')?.hasError('required')"
          >
            {{ passwordConfirmationErrorRequiredText }}
          </mat-error>
          <mat-error
            *ngIf="
              !registerForm.get('passwordConfirm')?.hasError('required') &&
              registerForm
                .get('passwordConfirm')
                ?.hasError('passwordsNotMatching')
            "
          >
            {{ passwordErrorMatchText }}
          </mat-error>
        </mat-form-field>

        <div *ngIf="this.tosUrl">
          <mat-checkbox
            formControlName="tos"
            required
            aria-label="{{ termsAndConditionsText }}"
          >
            <span>{{ termsAndConditionsText }}</span>
            <a target="_blank" [href]="this.tosUrl">
              {{ termsAndConditionsLinkText }}
            </a>
          </mat-checkbox>
        </div>

        <div *ngIf="this.privacyPolicyUrl">
          <mat-checkbox
            formControlName="privacyPolicy"
            required
            aria-label="{{ privacyPolicyText }}"
          >
            <span>{{ privacyPolicyText }}</span>
            <a target="_blank" [href]="this.privacyPolicyUrl">
              {{ privacyPolicyLinkText }}
            </a>
          </mat-checkbox>
        </div>

        <button
          aria-label="CREATE AN ACCOUNT"
          class="submit-button"
          id="createAccountButton"
          mat-raised-button
          [color]="colorAccent"
          [disabled]="registerForm.invalid"
          (click)="createAccount()"
        >
          {{ createAccountButtonText }}
        </button>
      </form>

      <div
        class="register"
        fxLayout="column"
        fxLayoutAlign="center center"
        [@animate]="{ value: '*', params: { duration: '300ms', y: '100px' } }"
      >
        <span class="text" [@animate]="{ value: '*', params: { x: '100px' } }">
          {{ alreadyHaveAccountText }}
        </span>
        <button
          id="loginButton"
          mat-button
          type="button"
          [@animate]="{ value: '*', params: { x: '-100px' } }"
          [color]="colorAccent"
          (click)="onLoginRequested.emit()"
        >
          {{ loginButtonText }}
        </button>
      </div>
    </div>
  </div>
</div>
